import { UserAvatar, IUserAvatarProps } from 'user/components/UserAvatar';

export const NavigationAvatar = (props: IUserAvatarProps) => (
    <UserAvatar size={32} {...props} />
);
